export default __webpack_public_path__ + "static/media/bootstrap_black.2d24a2ac.png";